<template>
  <span @click="onClickItemCheckbox">
    <el-checkbox v-model="checked" :disabled="item.inactive" />
  </span>
</template>
<script>
// onClickItemCheckbox
export default {
  props: {
    item: Object // eslint-disable-line
  },
  data: () => ({
    checked: false
  }),
  watch: {
    'item.selected': {
      handler: function(selected) {
        this.checked = this.item.selected
      },
      immediate: true
    }
  },
  mounted () {
    this.checked = this.item.selected
  },
  methods: {

    onClickItemCheckbox (event) {
      this.debug && console.log('onClickItemCheckbox')
      if (this.item.inactive !== true) {
        this.$emit('click:item', this.item, event)
        this.$nextTick(() => {
          this.debug && console.log('checked: %o', this.item.selected)
          this.checked = this.item.selected
        })
      }
      event.stopPropagation()
      event.preventDefault()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/FlightOrderRowCheck.vue